import api from "../services/api.js";

// import PopupMessage from "../components/common/PopupMessage.js";

export const AddActivityRequest = async (formData) => {
  try {
    const activity = await api.post("/activities/add-activity", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "add activity failed. Please try again.";
    console.error("Add Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const showAcademicActivities = async () => {
  try {
    const activity = await api.get("/activities/show-academic-activities");
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "show academic activity failed. Please try again.";
    console.error("Show Academic Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const showEntertainmentActivities = async () => {
  try {
    const activity = await api.get("/activities/show-entertainment-activities");
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Show Entertainment Activity failed. Please try again.";
    console.error("Show Entertainment Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const showCompetitionsActivities = async () => {
  try {
    const activity = await api.get("/activities/show-competitions-activities");
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Show Competitions Activity failed. Please try again.";
    console.error("Show Competitions Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const showSportsActivities = async () => {
  try {
    const activity = await api.get("/activities/show-sports-activities");
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Show Sports Activity failed. Please try again.";
    console.error("Show Sports Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const resent5_ActivitiesAPI = async () => {
  try {
    const activity = await api.get("/activities/resent-5-activities");
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Show latest Activity failed. Please try again.";
    console.error("Show latest Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const ActivityDetailsAPI = async (id) => {
  try {
    const activity = await api.get(`/activities/activity-details/${id}`);
    return activity.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Show Activity details failed. Please try again.";
    console.error("Show Sports Activity Failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const updateActivityRequest = async (activityId, payload) => {
  try {
    // لاحظ اننا بنبعت JSON عادي مش FormData لأننا مش بنرفع صور
    const response = await api.patch(
      `/activities/update-activit/${activityId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update activity",
    );
  }
};
